export default __webpack_public_path__ + "static/media/Trust-8.2f786134.svg";